module.exports = __webpack_public_path__ + "img/player.c024851c.png";